module.exports = __webpack_public_path__ + "static/media/cs-3.40c61e23.jpg";